// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { OrderTypeBaseParameters } from '@shared/commons/cache/OrderParams/order-type/OrderTypeBaseParameters';
import { ApplicationPanel } from './panels/ApplicationPanel';
export class OrderEntryBase extends ApplicationPanel {
    constructor() {
        super();
    }
    static PopulateOrderTypes(account, instrument, forbiddenOrderTypes, lastSelectedOrderType, mamMode) {
        mamMode = !!mamMode;
        const allowedOrderTypes = [];
        if (DataCache.OrderParameterContainer === null) {
            return allowedOrderTypes;
        }
        const orderTypes = DataCache.OrderParameterContainer.OrderTypes;
        const supportedParamObj = new OrderTypeBaseParameters(instrument, account);
        for (const key in orderTypes) {
            const orderType = orderTypes[key];
            const id = orderType.id();
            if (forbiddenOrderTypes === null || forbiddenOrderTypes === void 0 ? void 0 : forbiddenOrderTypes[id]) {
                continue;
            }
            if (!orderType.IsSupported(supportedParamObj)) {
                continue;
            }
            allowedOrderTypes.push(id);
        }
        return allowedOrderTypes;
    }
    static PopulateTifs(orderType, instrument) {
        let tifs = [];
        if (DataCache.OrderParameterContainer === null) {
            return tifs;
        }
        const supportedParamObj = new OrderTypeBaseParameters(instrument);
        const currentOrderType = DataCache.OrderParameterContainer.GetOrderType(orderType);
        if (isNullOrUndefined(currentOrderType) || !currentOrderType.IsSupported(supportedParamObj)) {
            return tifs;
        }
        const route = instrument.DataCache.Routes.getRouteByName(instrument.Route);
        const allowedTifs = route.DictOrderTypeTifs[orderType];
        if (isValidArray(allowedTifs)) {
            tifs = allowedTifs;
        }
        return tifs;
    }
}
ApplicationPanel.extendWith(OrderEntryBase, {});
